import React, { useState } from "react";
import { IonIcon } from '@ionic/react';
import { arrowBackOutline } from 'ionicons/icons';

const ShortForm: React.FC = () => {
    const [number, setNumber] = useState(generateRandomNumber());
    const [expandedForm, setExpandedForm] = useState<number[]>(splitNumber(number));
    const [blankIndex, setBlankIndex] = useState<number>(generateBlankIndex());
    const [userInput, setUserInput] = useState<string>("");
    const [error, setError] = useState(false);
    const [showImage, setShowImage] = useState(false);


    document.title = "Mamas Guidance - Class One - Mathematics - Number Math - Short Form"; // Set page title

    // Generate a random 3-digit number
    function generateRandomNumber() {
        return Math.floor(Math.random() * 900) + 100; // Random number from 100 to 999
    }

    // Split the number into expanded form
    function splitNumber(num: number) {
        const hundreds = Math.floor(num / 100) * 100;
        const tens = Math.floor((num % 100) / 10) * 10;
        const ones = num % 10;
        return [hundreds, tens, ones];
    }

    // Generate a random blank index
    function generateBlankIndex() {
        return Math.floor(Math.random() * 3); // Random index (0, 1, or 2)
    }

    // Handle form submission
    const handleSubmit = (e: React.FormEvent) => {
        e.preventDefault();
        const correctAnswer = expandedForm[blankIndex];
        if (parseInt(userInput) === correctAnswer) {
            setShowImage(true);
            // Generate a new question after a delay
            setTimeout(() => {
                const newNumber = generateRandomNumber();
                setNumber(newNumber);
                setExpandedForm(splitNumber(newNumber));
                setBlankIndex(generateBlankIndex());
                setUserInput("");
                setShowImage(false);
                setError(false);
            }, 5000);
        } else {
            setError(true);
        }
    };

    return (
        <>
            <div className="contentPart shortForm">
                {showImage ? (
                    <div className="image-container">
                        <img 
                            style={{ height: '150px' }} 
                            className="img-fluid" 
                            src={process.env.REACT_APP_WELDONE_LINK} 
                            alt="Well Done" 
                        />
                    </div>
                ) : (
                    <>
                        <div className="question" style={{marginBottom: '30px'}}>
                            <p className="text-center">{number}</p>
                            <p className="text-center">=</p>{" "}
                            <div className="mt-4 mb-4 text-center">
                            {expandedForm.map((part, index) => (
                                <React.Fragment key={index}>
                                    {index > 0 && " + "}
                                    {index === blankIndex ? (
                                        <input
                                            type="number"
                                            value={userInput}
                                            onChange={(e) => setUserInput(e.target.value)}
                                            placeholder="-"
                                            style={{ width: '30%', display: 'inline-block' }}
                                            className={`form-control blank-input ${error == true  ? 'error' : ''} `}
                                        />
                                    ) : (
                                        <span>{part}</span>
                                    )}
                                </React.Fragment>
                            ))}
                            </div>
                        </div>
                        <div className="text-center showMiddleOfPage">
                            <div className="background-blue" onClick={handleSubmit}>
                                Submit
                            </div>
                        </div>
                    </>
                )}
            </div>
        </>
    );
};

export default ShortForm;
